import styled from "styled-components";

export const CollapseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  & > div {
    width: 100%;
  }
`;

export const TriggersTemplatePagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: calc(100vh - 48px);
  overflow: hidden; 
`;

export const Content = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  width: 100%;
  max-width: 1400px;
  height: 100%;
`;

export const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 48px - 60px - 270px); 

  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  table {
    width: 100%;
  }

  table thead th:nth-child(1) {
    width: 300px;
  }

  table thead th:nth-child(2) {
    width: 500px;
  }

  table thead th:nth-child(3) {
    width: 300px;
  }

  table thead th:last-child {
    width: 100px;
  }
`;

export const NoDataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    font-family: ${(props) => props.theme.fonts.family.inter};
`      

export const NoDataTitle = styled.p`
    font-size: 20px;
    font-weight: 600;
    text-align: center;
`

export const NoDataDescription = styled.p`
    margin:0;
    font-size: 14px;
    color: ${(props) => props.theme.colors.davysGrey};
    text-align: center;
`
export const LoaderWrapper = styled.div`
  width: 100%;
  min-height: 240px;       /* asegura algo de alto para centrar verticalmente */
  display: flex;
  justify-content: center; /* centra horizontal */
  align-items: center;     /* centra vertical */
`;